export const INFO_COLLAPSE_ID = 'collapseInformation';
export const MSJ_ESTADO_INDENTIFICACION_MAPA = 'Estado identificación elemento mapa:';
export const MSJ_SELECCIONE_ELEMENTO_MAPA = 'Activa la opción de Identificación y da clic sobre algún elemento del mapa para ver su información';